import { Pipe, PipeTransform } from '@angular/core';

import { Document } from 'app/providers/storage-api/document.service';

@Pipe({
  name: 'isChecked',
  standalone: false,
})
export class IsCheckedPipe implements PipeTransform {
  transform(
    selectedDocs: Document[],
    pageCount: number
  ): { checked: boolean; indeterminate: boolean } {
    const count = selectedDocs?.length ?? 0;

    return {
      checked: this.getBulkCheckedValue(count, pageCount),
      indeterminate: this.getBulkIndeterminateValue(count, pageCount),
    };
  }

  private getBulkCheckedValue(selectedDocsCount: number, pageCount: number): boolean {
    return pageCount > 0 && pageCount === selectedDocsCount;
  }

  private getBulkIndeterminateValue(selectedDocsCount: number, pageCount: number): boolean {
    return pageCount > 0 && selectedDocsCount > 0 && selectedDocsCount < pageCount;
  }
}
